import { useEffect, useState } from 'react';
// import axios from '@/services/axiosInstance';
import axiosInstance from "../../helpers/Axios";

type TeamMember = {
  teamId: number;
  firstName: string;
  lastName: string;
  imageUrl?: string;
  description: string;
};

const Team = () => {
  const [team, setTeam] = useState<TeamMember[]>([]);

  useEffect(() => {
    axiosInstance.get('/team').then(res => setTeam(res.data));
  }, []);

  return (
    <div>
      <h2>L'équipe</h2>

      {team.map(member => (
        <div key={member.teamId} className="team-perso">
          <h4>{member.firstName} {member.lastName}</h4>

          <div className="flex">
            {member.imageUrl && (
              <img
                src={`${import.meta.env.VITE_BACKEND_URL}${member.imageUrl}`}
                alt={`${member.firstName} ${member.lastName}`}
              />
            )}

            <div className="team-perso-text">
              {member.description
                .split('\n\n')
                .map((p, i) => <p key={i}>{p}</p>)
              }
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Team;


{/*
  // import React from 'react';
// import { Link } from 'react-router-dom';

const Team = () => {

  return (
    <div>
      <h2>L'équipe</h2>
      <div className="team-perso">
        <h4>Didier Oriol</h4>
        <div className="flex">
          <img alt="Didier Oriol" src="images/team/didier.jpg" />
          <div className="team-perso-text">
            <p>Depuis toujours, « croire en ses rêves » résonne profondément en moi. Adolescent curieux, j'ai trouvé dans le cirque un refuge et une source d'émerveillement et d'épanouissement, en accord avec mes valeurs. Fasciné par le mouvement, la performance et la créativité, c'est tout naturellement que je me suis dirigé vers une carrière artistique.<br />
              Porté par le goût de la rencontre et la conviction que le spectacle tisse du lien social, j'ai persévéré et choisi un métier réunissant toutes mes passions.<br />
              Depuis le début , j'enseigne et je me produis sur scène.<br />
              J'ai obtenu un certificat de réussite en 95 à l'E.N.A.C actuelle E.S.A.C fut un turbo pour ma carrière professionnelle et artistique.<br />
              Diplômé d'un CAP (certificat d'aptitude professionnelle en science de l'éducation, enseignement supérieur de type court) cette année 2025 j'ai travaillé dur pour pouvoir véritablement enseigner ce qui m'anime depuis longtemps : les arts du cirque en secondaire.<br />
              Artiste et pédagogue depuis plus de 30 ans, je vis de mon art, au travers d'expériences riches et variées. Moi et Antoine Dethy nous sommes les fondateurs et acteurs de l'actuelle compagnie du Duo Tamba.<br />
              Compagnie qui allie cirque, musique en live, et personnage décalé et attachant nous proposons un spectacle tout public.<br />
              Directeur artistique depuis plus de 15 ans de l'a.s.b.l. Créacirque à Namur l'école de cirque de Namur, où je transmets ma passion, ma technique et ma sensibilité avec enthousiasme à des publics diversifiés.<br />
              "Un objectif est un rêve auquel on place une échéance" Napoleon Hill<br />
              Si le cirque, c'est la vie… pour moi, c'est ma vie ! 🙂</p>
          </div>
        </div>
      </div>
      <div className="team-perso">
        <h4>Antoine Dethy</h4>
        <div className="flex">
          <img alt="Antoine Dethy" src="images/team/antoine.png" />
          <div className="team-perso-flex">
            <p>Jongleur depuis son enfance, il découvre le diabolo à huit ans.
              Il ne le lâchera plus.</p>
            <p>Il suivra, à différentes périodes, des cours de jonglerie et acrobatie avec Didier Oriol et inventera ses propres figures de diabolo.
              Il entre à l'Ecole Supérieur des Arts du Cirque qui le poussera à développer son style, mêlant au diabolo la dance et l'acrobatie.</p>
            <p>Aujourd'hui, artiste de cirque professionnel, il a créé son numéro en solo: "Tac!", et travail avec différentes compagnies tel que cie Airblow ou le Duo Tamba.</p>
            <p>Et bien sur, il enseigne la jonglerie sous toutes ses formes.</p>
          </div>
        </div>
      </div>
      <div className="team-perso">
        <h4>Nell Georges</h4>
        <div className="flex">
          <img alt="Nell Georges" src="images/team/nell.jpg" />
          <div className="team-perso-flex">
            <p>Je m'appelle Nell. Je fais du cirque aérien depuis toute petite.</p>
            <p>J'ai la chance de faire également de la musique et d'être régisseuse de théâtre.  Les arts vivants, c'est ma deuxième maison !</p>
            <p>Je me sers de mes connaissances dans différents domaines pour les cours d'aérien.  Au programme : de la technique (tissu, trapèze, cerceau), une conscience de son corps, des mouvements qui nous entourent et nous traversent, du contact humain, de la bienveillance, de la musique, un peu de folie <span role="img" aria-label='folie'>🎉</span> et un brin de magie <span role="img" aria-label='magie'>✨</span>.</p>
          </div>
        </div>
      </div>
    </div>
  )
};

export default Team;

  */}